import { z } from "zod";

import { SCHEMA_LIMITS, createMaxLengthMessage } from "./constants";
import {
  CreateEngResourceAfterUploadSchema,
  DeleteEngResourceSchema,
} from "./engagement";

// File size constants
export const MAX_FILE_SIZE_MB = 9;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Allowed file types
export const ALLOWED_FILE_EXTENSIONS = [
  ".pdf",
  ".svg",
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".doc",
  ".docx",
] as const;

export const ALLOWED_MIME_TYPES = [
  "application/pdf",
  "image/svg+xml",
  "image/png",
  "image/jpeg",
  "image/gif",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
] as const;

// Human-readable file type description
export const ALLOWED_FILE_TYPES_DESCRIPTION =
  "PDF, SVG, PNG, JPG, GIF, DOC, or DOCX files";

export const AddEngagementResourceSchema =
  CreateEngResourceAfterUploadSchema.extend({
    uploadModel: z.enum(["file", "url", "agreement"]),
    file: z.instanceof(File).optional(),
  }).refine(
    (data) => {
      if (data.uploadModel === "file" && !data.file) {
        return false;
      }
      if (data.uploadModel === "url" && !data.externalLinkUrl) {
        return false;
      }
      return true;
    },
    {
      message:
        "Please provide either a file or URL based on the selected upload model",
    },
  );

export const UpdateEngagementResourceSchema = z.object({
  resourceId: z.string().uuid(),
  uploadModel: z.enum(["file", "url", "agreement"]),
  title: z
    .string()
    .trim()
    .min(1, "Title is required")
    .max(
      SCHEMA_LIMITS.RESOURCE_TITLE_MAX_LENGTH,
      createMaxLengthMessage("Title", SCHEMA_LIMITS.RESOURCE_TITLE_MAX_LENGTH),
    )
    .optional(),
  externalLinkUrl: z.string().url().optional(),
  newName: z.string().optional(),
  tagIds: z.array(z.string().uuid()).default([]),
  file: z.instanceof(File).optional(),
  engagementId: z.string().optional(),
  sessionId: z.string().optional(),
});

export const DeleteResourceSchema = DeleteEngResourceSchema;
export type AddEngagementResourceInput = z.infer<
  typeof AddEngagementResourceSchema
>;
export type UpdateEngagementResourceInput = z.infer<
  typeof UpdateEngagementResourceSchema
>;
export type DeleteResourceInput = z.infer<typeof DeleteResourceSchema>;
